import Vue from 'vue'
import VueRouter from 'vue-router'
import homeIndex from '../views/homeIndex.vue'
import goodsInfo from '../views/goodsInfo.vue'
import contractList from '../views/contractList.vue'
import contractInfo from '../views/contractInfo.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'homeIndex',
    component: homeIndex
  },
  {
    path: '/goodsInfo.wingor',
    name: 'goodsInfo',
    component: goodsInfo,
  },
  {
    path: '/contract.wingor',
    name: 'contractList',
    component: contractList,
    meta: { 
      requireAuto: true,
    }
  },
  {
    path: '/contractInfo.wingor',
    name: 'contractInfo',
    component: contractInfo,
    meta: { 
      requireAuto: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 路由守卫
router.beforeEach((to, from, next) => {

  
  //获取token
  const tokenStr = localStorage.getItem('token')
  // next()
  //判断该路由是否需要登录权限
  if (to.meta.requireAuto) {
    // 判断本地是否存储token
    if (tokenStr) {
      next()
    } else {
      // 没有token
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
  
  
  if (to.name === 'homeIndex') {
    localStorage.removeItem('token')
  } else {
    // 放行
    next()
  }
})


export default router
